export * from './CommentRectTextIcon';
export * from './CommentRectTextIcon16Light';
export * from './CommentRectTextIcon16Regular';
export * from './CommentRectTextIcon16Solid';
export * from './CommentRectTextIcon20Light';
export * from './CommentRectTextIcon20Regular';
export * from './CommentRectTextIcon20Solid';
export * from './CommentRectTextIcon24Regular';
export * from './CommentRectTextIcon24Solid';
export * from './CommentRectTextIcon32Regular';
export * from './CommentRectTextIcon64Regular';
